import { render, staticRenderFns } from "./BillDetailsPanel.vue?vue&type=template&id=675329b8&scoped=true"
import script from "./BillDetailsPanel.vue?vue&type=script&lang=js"
export * from "./BillDetailsPanel.vue?vue&type=script&lang=js"
import style0 from "./BillDetailsPanel.vue?vue&type=style&index=0&id=675329b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675329b8",
  null
  
)

export default component.exports